import _ from 'lodash';

import CMSModel from '@/visa-application/models/CMSModel';
import FileCMSModel from '@/visa-application/models/FileCMSModel';

export interface Carousel {
  link: string;
  imgLink: string;
}
export default class ResidenceCountryCMSModel implements CMSModel {
  title = '';
  subtitle = '';
  selectInstruction = '';
  selectDefaultOption = '';
  selectWarning = '';
  popupTitle = '';
  popupContent = '';
  popupLanguageAlertMsg = '';
  popupContentNotSelectResidenceCountry = '';
  countryImage: FileCMSModel = new FileCMSModel();
  countryFlag: FileCMSModel = new FileCMSModel();
  meta_title = '';
  meta_description = '';
  meta_keywords = '';
  welcome_header = '';
  welcome_content = '';
  splash_header = '';
  carousel: Carousel[] = [];
  carousel_mobile: Carousel[] = [];
  swipeAutoplayTime = 0;

  map(obj: any): void {
    this.title = _.get(obj, 'translation[0].title', '');
    this.subtitle = _.get(obj, 'translation[0].subtitle', '');
    this.selectInstruction = _.get(obj, 'translation[0].select_instruction', '');
    this.selectDefaultOption = _.get(obj, 'translation[0].select_default_option', '');
    this.selectWarning = _.get(obj, 'translation[0].select_warning', '');
    this.popupTitle = _.get(obj, 'translation[0].popup_title', '');
    this.popupContent = _.get(obj, 'translation[0].popup_content', '');
    this.popupLanguageAlertMsg = _.get(obj, 'translation[0].popup_language_alert_msg', '');
    this.popupContentNotSelectResidenceCountry = _.get(obj, 'translation[0].popup_content_not_select_residence_country', '');
    this.countryImage.map(_.get(obj, 'country_image', undefined));
    this.countryFlag.map(_.get(obj, 'country_flag', undefined));
    this.meta_title = _.get(obj, 'translation[0].meta_title', '');
    this.meta_description = _.get(obj, 'translation[0].meta_description', '');
    this.meta_keywords = _.get(obj, 'translation[0].meta_keywords', '');
    this.welcome_header = _.get(obj, 'translation[0].welcome_header', '');
    this.welcome_content = _.get(obj, 'translation[0].welcome_content', '');
    this.splash_header = _.get(obj, 'translation[0].splash_header', '');
    this.carousel = _.get(obj, 'translation[0].carousel', '');
    this.carousel_mobile = _.get(obj, 'translation[0].carousel_mobile', '');
    this.swipeAutoplayTime = _.get(obj, 'swipe_autoplay_time', '');
  }
}
